module.exports = {
	"articleTitle1": "Do it by the book",
	"catImage": "bluestar.png",
	"totalCats": 2,
	"name": "Hatcher Graduate Library",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/campus-life/sustainability-town-hall-discusses-long-term-goals",
	"articleSnippet1": "Sep 20, 2006 ... Have sex in the Harlan Hatcher Graduate Library's stacks before ... Jessica \nBoullion: Steps one through six to have sex in the Graduate Library.",
	"articleSnippet2": "Nov 17, 2016 ... Students and staff filled the Hatcher Graduate Library gallery Thursday for the \nannual Campus Sustainability Town Hall Meeting to discuss the ...",
	"totalMisc": 1,
	"articleTitle2": "In town hall, campus community reflects on sustainability initiatives ...",
	"address": "913 S University Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161208/jam.NEW_.FeatureFinalsStudying.12.06.16.001.jpg?itok=AuFx7yqb",
			"author": "Jeremy Mitnick",
			"caption": "LSA junior Sejal Mehta prepares for her Physical Chemistry final in the Hatcher Graduate Library on Tuesday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170119/kev.FEA_.TransportationCollection.040.jpg?itok=j4EnYdLy",
			"author": "Kevin Zheng",
			"caption": "Library Associate Liz Settoducato and Outreach Librarian Juli McLoone exhibit the Transportation History Collection and the Hubbard Collection of Imaginary Voyages at Hatcher on Thursday"
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161201/elr.FEA_.DeidreDeLaCruz.12.1.16001%20copy.jpg?itok=G8DomZpJ",
			"author": "Emma Richter",
			"caption": "Deidre de la Cruz , professor of History and Southeast Asian Studies, discusses her book \"Mother Figured: Marian Apparitions and the Making of a Filipino Universal\" at Hatcher Graduate Library on Wednesday."
		}
	],
	"position": {
		"lat": 42.276334,
		"lng": -83.738233
	},
	"tips": [
		{
			"text": "Basement of Hatcher is almost ALWAYS empty and has super comfy couches and chairs to sit in ... not just desks and chairs!",
			"person": "Erika Shevchek"
		},
		{
			"text": "The North stacks have individual desks with outlets nearby and are usually silent",
			"person": "Connor Grady"
		},
		{
			"text": "The stacks (some of which have closed doors) are good for crying, find one later in the night and farther from civilization and have a good cry!!!!",
			"person": "Aisvaryah Chandrakanthan"
		}
	],
	"bathroomrating": [
		{
			"rating": 2,
			"bathroom": "2nd Floor by Computer Lab"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"library": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/hatcher.json
// module id = 887
// module chunks = 0